import { useRef } from "react";
import ModalPop from "./ModalPop";
import useDeviceType from "../common/useDeviceType";

interface Benefit {
  icon: string;
  title: string;
  highlight: string;
}

const benefits: Benefit[] = [
  {
    icon: "/images/about1.png",
    title: "365일 24시간",
    highlight: "긴급출동",
  },
  {
    icon: "/images/about2.png",
    title: "과잉견적X",
    highlight: "정직한 견적",
  },
  {
    icon: "/images/about3.png",
    title: "미해결시 비용 0원",
    highlight: "100% 완벽해결",
  },
  {
    icon: "/images/about4.png",
    title: "전문 장비 및",
    highlight: "최고의 인력",
  },
];

export default function About() {
  const isMobile = useDeviceType();

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <section className="w-full bg-white py-14 md:py-20">
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="mx-auto max-w-[1100px] px-4 md:px-8">
        {/* Card */}
        <div data-aos="fade-up">
          <img
            src={isMobile ? "/images/aboutMo.png?v=2" : "/images/aboutPc.png?v=2"}
            alt="하수구원킬케어 약속"
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* Icon grid */}
        <div className="grid grid-cols-2 mt-5 md:grid-cols-4 gap-3 lg:gap-5 lg:px-5">
          {benefits.map((benefit, i) => (
            <div
              key={benefit.title}
              className="flex flex-col items-center gap-3 px-2 py-4 text-center border-2 border-primary rounded-xl"
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white pt-3 lg:h-20 lg:w-20">
                <img
                  src={benefit.icon}
                  alt={`${benefit.title} ${benefit.highlight}`}
                  className="h-full w-full object-contain "
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <p className="lg:text-xl">
                {benefit.title}
                <br />
                <span>{benefit.highlight}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
      {/* CTA buttons */}
      <div className="mt-14 grid lg:grid-cols-2 gap-3 md:mt-20 max-w-[700px] mx-auto px-4">
        <button
          type="button"
          onClick={openfunc}
          className="w-full rounded-lg bg-gradient-to-r to-secondary via-[#3d7af6] from-[#3d7af6] pt-2 pb-1 text-center text-base text-white transition-colors sm:w-auto"
        >
          <h3>상담신청</h3>
        </button>
        <button
          onClick={() => (window.location.href = "tel:010-8123-8285")}
          className="w-full rounded-lg border-2 bg-red border-red pt-2 pb-1 text-center text-point transition-colors sm:w-auto text-base"
        >
          <h3>
            긴급출동 <span className="text-base">(365일 24시간)</span>
          </h3>
        </button>
      </div>
    </section>
  );
}
